module.exports = __webpack_public_path__ + "media/customizations/bryson/back-e26192eca362c5836a4420ec16b3c843.jpg";